<template>
  <v-card flat class="pa-6 fill-height d-flex flex-column" :to="to">

    <!-- Icon chip + status pill (only when there's an icon or a pill to show) -->
    <div v-if="icon || pill" class="d-flex align-start justify-space-between mb-5">
      <v-avatar v-if="icon" rounded="lg" size="52" color="#e9eef5">
        <v-icon color="primary">{{ icon }}</v-icon>
      </v-avatar>
      <v-spacer v-else />

      <template v-if="pill">
        <v-progress-circular
          v-if="pill.loading"
          indeterminate
          size="18"
          width="2"
          color="grey lighten-1"
          class="mt-1"
        />
        <v-chip
          v-else
          small
          label
          outlined
          :color="pill.color"
          class="font-weight-bold text-uppercase"
        >{{ pill.text }}</v-chip>
      </template>
    </div>

    <!-- Title + description -->
    <div class="text-h6 font-weight-bold mb-1">{{ title }}</div>
    <div class="dashboard-byline text--secondary mb-2">{{ description }}</div>

    <!-- CTA pinned to the bottom -->
    <v-spacer />
    <v-divider class="mb-3" />
    <div
      class="d-flex align-center font-weight-medium text-body-2"
      :class="linkTextClass"
    >
      {{ cta }}
      <v-icon small :color="linkColor" class="ml-2">fa-arrow-right</v-icon>
    </div>

  </v-card>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    to: { type: [String, Object], default: null },
    cta: { type: String, default: '' },
    // { text, color } for a status chip, { loading: true } for a spinner, or null for none.
    pill: { type: Object, default: null }
  },
  computed: {
    // The brand primary blue is too dark on dark backgrounds, so use a lighter
    // blue for the CTA link there (mirrors the tab treatment in global.scss).
    linkColor () {
      return this.$vuetify.theme.dark ? 'light-blue lighten-2' : 'primary'
    },
    linkTextClass () {
      return this.$vuetify.theme.dark ? 'light-blue--text text--lighten-2' : 'primary--text'
    }
  }
}
</script>
